// extracted by mini-css-extract-plugin
export default {"selectPaymentMethod":"JTkiQ2iKyfy2KYBl0T0r","card":"BGr3v8jmRgmyE1mStVg4"};